<template>
  <svg xmlns="http://www.w3.org/2000/svg" width='40px' viewBox="0 0 32 32">
    <path
      d="M29.44,16.318c0-.993-.089-1.947-.255-2.864h-13.185v5.422h7.535c-.331,1.744-1.324,3.22-2.813,4.213v3.525h4.544c2.647-2.444,4.175-6.033,4.175-10.296Z"
      opacity=".4"
    ></path>
    <path
      d="M16,30c3.78,0,6.949-1.247,9.265-3.385l-4.544-3.525c-1.247,.84-2.838,1.349-4.722,1.349-3.64,0-6.733-2.456-7.84-5.765l-2.717,2.09-1.941,1.525c2.304,4.569,7.025,7.713,12.498,7.713Z"
    ></path>
    <path
      d="M8.16,18.66c-.28-.84-.445-1.731-.445-2.66s.165-1.82,.445-2.66v-3.615H3.502c-.955,1.884-1.502,4.009-1.502,6.275s.547,4.391,1.502,6.275h3.332s1.327-3.615,1.327-3.615Z"
      opacity=".4"
    ></path>
    <path
      d="M16,7.575c2.062,0,3.895,.713,5.358,2.087l4.009-4.009c-2.431-2.265-5.587-3.653-9.367-3.653-5.473,0-10.195,3.144-12.498,7.725l4.658,3.615c1.107-3.309,4.2-5.765,7.84-5.765Z"
    ></path>
  </svg>
  <svg
  v-if='false'
    width="22"
    height="23"
    viewBox="0 0 22 23"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M10.9941 10.3812V13.1812H14.9547C14.3765 14.8109 12.8197 15.9812 10.9941 15.9812C8.67854 15.9812 6.79414 14.0968 6.79414 11.7812C6.79414 9.46565 8.67854 7.58125 10.9941 7.58125C11.9979 7.58125 12.9639 7.94105 13.7143 8.59485L15.5539 6.48365C14.2939 5.38605 12.6755 4.78125 10.9941 4.78125C7.13434 4.78125 3.99414 7.92145 3.99414 11.7812C3.99414 15.6411 7.13434 18.7812 10.9941 18.7812C14.8539 18.7812 17.9941 15.6411 17.9941 11.7812V10.3812H10.9941Z"
      fill="#22282B"
    />
    <mask
      id="mask0_534_622"
      style="mask-type: luminance"
      maskUnits="userSpaceOnUse"
      x="3"
      y="4"
      width="15"
      height="15"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M10.9941 10.3812V13.1812H14.9547C14.3765 14.8109 12.8197 15.9812 10.9941 15.9812C8.67854 15.9812 6.79414 14.0968 6.79414 11.7812C6.79414 9.46565 8.67854 7.58125 10.9941 7.58125C11.9979 7.58125 12.9639 7.94105 13.7143 8.59485L15.5539 6.48365C14.2939 5.38605 12.6755 4.78125 10.9941 4.78125C7.13434 4.78125 3.99414 7.92145 3.99414 11.7812C3.99414 15.6411 7.13434 18.7812 10.9941 18.7812C14.8539 18.7812 17.9941 15.6411 17.9941 11.7812V10.3812H10.9941Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask0_534_622)"></g>
  </svg>
</template>

<script>
export default {
  name: "GoogleIcon",
};
</script>

<style lang="scss" scoped></style>
